import { firstItem } from "lib/utils";
import { sourceFields } from "./aggregationFields";

export const createRequestBody = ({ query, filters, dates, aggregations = [], size, from, sort }, aggs) => {
  try {
    const request = {
      query: {
        bool: {
          must: [...queryTerms(query), ...filterTerms(filters), ...dateFilters(dates)],
        },
      },
      aggs: aggregations,
      sort,
      size,
      _source: sourceFields,
      from,
      highlight: {
        fields: {
          "content.body": {
            fragment_size: 150,
            number_of_fragments: 1,
          },
          title: {
            fragment_size: 150,
            number_of_fragments: 1,
          },
        },
      },
    };
    if (currencyExist(filters)) {
      request.query.bool.must_not = [
        {
          term: { "txCategories.en": "Equity" },
        },
      ];
    }

    if (!aggs) delete request.aggs;

    return request;
  } catch (err) {
    console.error("Unable to create search request: ", err);
    return {};
  }
};

export const currencyExist = (filters) =>
  Object.prototype.hasOwnProperty.call(filters, "currencies.en") ||
  Object.prototype.hasOwnProperty.call(filters, "currencies.ja");

export const queryTerms = ({ q = [], title = [] }) => {
  const _keywords = q.map((q) => `(${q.trim()})`);
  const _titles = title.map((t) => `title:(${t.trim()})`);
  const union = [..._keywords, ..._titles];
  if (!union.length) return [];
  return [{ query_string: { query: union.join(" AND ") } }];
};

// filters: {regions.en: ["EMEA", "Japan"] ... } -> bool: should: [{regions.en: "EMEA"}, {regions.en: "Japan"} ... ]
const filterTerms = (filters = {}) =>
  Object.entries(filters).map(([key, arr]) => ({
    bool: {
      should: toArray(arr).map((value) => ({ term: { [key]: value } })),
    },
  }));

const dateFilters = ({ fromDate, toDate }) => [
  ...(fromDate ? [{ range: { publicationDate: { gte: firstItem(fromDate) } } }] : []),
  ...(toDate ? [{ range: { publicationDate: { lte: firstItem(toDate) } } }] : []),
];

const toArray = (item) => (Array.isArray(item) ? item : [item]);
